import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';
import classNames from 'classnames';
import { Form, Input, Select, Spin, Row, Col, Card, Button, Icon } from 'antd';
import ButtonBar from '../../ButtonBar/ButtonBar';
import { TrashIcon } from '../../Icons';
import { ACTION_APP_GO_TO_ROUTE } from '../../../models/app';
import {
  ACTION_PAGEGROUPS_CREATE,
  ACTION_PAGEGROUPS_UPDATE,
  ACTION_PAGEGROUPS_LOAD_ITEM,
} from '../../../models/pageGroups';
import { ACTION_HEADER_UPDATE } from '../../../models/header';
import { ROUTE_PAGE_GROUPS_LIST } from '../../../routes';
import styles from './../styles.less';

const { Item } = Form;
const { Option } = Select;

const Operators = {
  starts_with: 'starts_with',
  ends_with: 'ends_with',
  eq: 'eq',
  regexp: 'regexp',
  contains: 'contains',
};

class PageGroupsItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projectId:
        this.props.app.currentProjectId || this.props.match.params.projectId,
      copyId: this.props.match.params.copyPageGroupId
        ? this.props.match.params.copyPageGroupId
        : null,
      pageGroup: {
        id: this.props.match.params.pageGroupId
          ? this.props.match.params.pageGroupId
          : null,
        name: '',
        url_patterns: [
          {
            operator: '',
            value: '',
          },
        ],
      },
    };
  }

  componentDidMount() {
    const {
      projectId,
      copyId,
      pageGroup: { id },
    } = this.state;

    if (id || copyId) {
      const payload = {
        projectId,
        id: id || copyId,
      };

      this.props
        .dispatch({ type: ACTION_PAGEGROUPS_LOAD_ITEM, payload })
        .then((response) => {
          this.setState({
            pageGroup: response,
          });
        });
    }

    if (copyId) {
      this.setState(state => ({
        pageGroup: {
          ...state.pageGroup,
          id: null,
        },
      }));
    }

    this.props.dispatch({
      type: ACTION_HEADER_UPDATE,
      payload: {
        title: id
          ? 'Component.PageGroups.Form.Edit'
          : 'Component.PageGroups.Form.New',
      },
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { getFieldsValue, validateFields } = this.props.form;
    validateFields((err) => {
      if (!err) {
        const { name, url_patterns } = getFieldsValue();
        this.savePageGroup({ name, url_patterns });
      }
    });
  };

  savePageGroup(data) {
    const {
      projectId,
      pageGroup: { id },
    } = this.state;
    this.props.dispatch({
      type: id ? ACTION_PAGEGROUPS_UPDATE : ACTION_PAGEGROUPS_CREATE,
      payload: {
        id,
        data,
        projectId,
      },
    });
  }

  goToPageGroups = () => {
    const projectId = this.state.projectId;
    this.props.dispatch({
      type: ACTION_APP_GO_TO_ROUTE,
      payload: { routeName: ROUTE_PAGE_GROUPS_LIST, projectId },
    });
  };

  newUrlSet = () => {
    const { pageGroup } = this.state;
    pageGroup.url_patterns.push({
      operator: '',
      value: '',
    });

    this.setState({ pageGroup });
  };

  deleteUrlSet = index => () => {
    const { pageGroup } = this.state;
    pageGroup.url_patterns.splice(index, 1);
    this.setState({
      pageGroup,
    });
  };

  renderOperatorField = () => {
    const operators = [
      {
        id: Operators.eq,
        label: this.props.intl.formatMessage({
          id: 'Component.PageGroups.Operator.eq',
        }),
      },
      {
        id: Operators.contains,
        label: this.props.intl.formatMessage({
          id: 'Component.PageGroups.Operator.contains',
        }),
      },
      {
        id: Operators.starts_with,
        label: this.props.intl.formatMessage({
          id: 'Component.PageGroups.Operator.starts_with',
        }),
      },
      {
        id: Operators.ends_with,
        label: this.props.intl.formatMessage({
          id: 'Component.PageGroups.Operator.ends_with',
        }),
      },
      {
        id: Operators.regexp,
        label: this.props.intl.formatMessage({
          id: 'Component.PageGroups.Operator.regexp',
        }),
      },
    ];

    return (
      <Select>
        {operators.map(i => (
          <Option key={i.id} value={i.id}>
            {i.label}
          </Option>
        ))}
      </Select>
    );
  };

  render() {
    const { pageGroup } = this.state;
    const { loading, form, intl } = this.props;
    const { getFieldDecorator } = form;
    return (
      <Spin
        spinning={
          !!loading.effects[ACTION_PAGEGROUPS_CREATE] ||
          !!loading.effects[ACTION_PAGEGROUPS_UPDATE] ||
          !!loading.effects[ACTION_PAGEGROUPS_LOAD_ITEM]
        }
      >
        <div className={styles.containerLarge}>
          <Form onSubmit={this.handleSubmit}>
            <Card>
              <Row>
                <Col>
                  <Item
                    label={
                      <FormattedMessage id="Component.PageGroups.Form.Name" />
                    }
                  >
                    {getFieldDecorator('name', {
                      initialValue: pageGroup.name,
                      rules: [
                        {
                          required: true,
                          min: 3,
                          max: 255,
                          message: intl.formatMessage({
                            id: 'Component.PageGroups.Validation.Name',
                          }),
                        },
                      ],
                    })(<Input maxLength={255} type="text" />)}
                  </Item>
                </Col>
              </Row>
            </Card>
            <Card
              className="custom-card"
              title={intl.formatMessage({ id: 'Component.PageGroups.URLset' })}
            >
              {pageGroup.url_patterns.map((item, index) => (
                <Row key={index} gutter={6}>
                  <Col xl={4} lg={12} sm={24}>
                    <Item
                      label={
                        index === 0 &&
                        intl.formatMessage({
                          id: 'Component.PageGroups.Form.Operator',
                        })
                      }
                    >
                      {getFieldDecorator(`url_patterns[${index}].operator`, {
                        initialValue: item.operator,
                        rules: [
                          {
                            required: true,
                            message: intl.formatMessage({
                              id: 'Component.PageGroups.Validation.Operator',
                            }),
                          },
                        ],
                      })(this.renderOperatorField())}
                    </Item>
                  </Col>
                  <Col xl={20} lg={12} sm={24}>
                    <Item
                      label={
                        index === 0 &&
                        intl.formatMessage({
                          id: 'Component.PageGroups.Form.Value',
                        })
                      }
                    >
                      {getFieldDecorator(`url_patterns[${index}].value`, {
                        initialValue: item.value,
                        rules: [
                          {
                            required: true,
                            min: 1,
                            max: 4000,
                            message: intl.formatMessage({
                              id: 'Component.PageGroups.Validation.Value',
                            }),
                          },
                        ],
                      })(
                        <Input
                          maxLength={1000}
                          addonBefore="http(s)://"
                          addonAfter={
                            <span
                              onClick={this.deleteUrlSet(index)}
                              className={styles.delete}
                            >
                              <TrashIcon />
                            </span>
                          }
                          className={classNames({
                            [styles.invalid]:
                            item.operator === Operators.eq && !item.valid,
                          })}
                          type="text"
                        />,
                      )}
                    </Item>
                  </Col>
                </Row>
              ))}
              <Row type="flex" justify="end">
                <Button size="large" type="primary" onClick={this.newUrlSet}>
                  <Icon type="plus" />
                  <FormattedMessage id="Component.PageGroups.Form.Add" />
                </Button>
              </Row>
            </Card>
            <ButtonBar cancelAction={this.goToPageGroups} />
          </Form>
        </div>
      </Spin>
    );
  }
}

export default connect(({ app, loading }) => ({ app, loading }))(
  Form.create()(injectIntl(PageGroupsItem)),
);



// WEBPACK FOOTER //
// ./src/components/PageGroups/PageGroupsItem/index.js